import { render } from "./AGCAREDetail.vue?vue&type=template&id=50944f49&scoped=true"
import script from "./AGCAREDetail.vue?vue&type=script&lang=js"
export * from "./AGCAREDetail.vue?vue&type=script&lang=js"

import "./AGCAREDetail.vue?vue&type=style&index=0&id=50944f49&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50944f49"]])

export default __exports__